import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';

@Component({
    standalone: false,
    selector: 'particle-dac6-case-hash-tag-dialog',
  templateUrl: './dac6-case-hash-tag-dialog.component.html',
  styleUrls: ['./dac6-case-hash-tag-dialog.component.scss'],
})
export class Dac6CaseHashTagDialogComponent implements OnInit, IDialogView {
  data: DialogModel;
  sourceType: string;
  invalidateSubject: InvalidateSubject;
  caseType: string;
  selectedCaseId: string;
  selectedCaseGuid: string;
  constructor() {
    this.invalidateSubject = new InvalidateSubject();
    this.sourceType = 'CaseHashtagDialog';
    this.caseType = 'existing';
    this.selectedCaseId = '';
    this.selectedCaseGuid = '';
  }

  ngOnInit() {
  }


  onOkClicked(): boolean {
    this.data.input.caseId = this.selectedCaseId;
    this.data.input.caseGuid = this.selectedCaseGuid;
    this.data.input.caseType = this.caseType;
    return true;
  }

  onCaseTypeChange(event) {
    this.selectedCaseId = '';
    this.selectedCaseGuid = '';
  }

  onSelectionChanged(event) {
    console.log(event);
    this.selectedCaseGuid = event.selectedRows[0].dataItem.cells['CaseId'].value;
    this.selectedCaseId = event.selectedRows[0].dataItem.cells['CaseId'].displayText;
  }

}
